import React, { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CircleButton, ColorInput, Input, Toggle } from '@ui';
import useTranslation from '@app/hooks/use-translation';
type ConditionalFormattingNestedFieldPropsType = {
  nestedFieldIndex: number;
  oneOnly?: boolean;
};
const ConditionalFormattingNestedField: FC<ConditionalFormattingNestedFieldPropsType> = (props) => {
  const { nestedFieldIndex, oneOnly } = props;
  const { t } = useTranslation('pages.chartPage');
  // css
  const valuesLabelPathClassName =
    'text-[15px] font-[500] leading-[16.4px] tracking-tight text-0color whitespace-nowrap';
  const fieldAndLabelBlock = 'grid grid-cols-[250px_1fr] items-center w-full';
  const firstBlockValueWidth = 'w-[280px]';
  // hook form
  const conditionFormattingDefaultValue = {
    value: [0, 0],
    color: '#c592f7',
  };
  const { control, setValue, register, watch } = useFormContext();
  const {
    fields: conditionalFormattingFields,
    append: appendConditionalFormattingField,
    remove: removeConditionalFormattingField,
    replace: replaceConditionalFormattingField,
  } = useFieldArray({
    name: `settings.data[${nestedFieldIndex}].conditional_formatting`,
    control,
  });
  return (
    <>
      {watch('settings.type') !== 'columnchart' &&
        watch('settings.type') !== 'linechart' &&
        watch('settings.type') !== 'piechart' && (
          <div className=" w-[860px] relative">
            <div className={fieldAndLabelBlock}>
              <span className={valuesLabelPathClassName}>{t('conditional_formatting')}</span>
              <div className="w-[270px]">
                <Toggle
                  checked={conditionalFormattingFields.length !== 0}
                  onChecked={() =>
                    conditionalFormattingFields.length === 0
                      ? appendConditionalFormattingField(conditionFormattingDefaultValue)
                      : replaceConditionalFormattingField([])
                  }
                />
              </div>
            </div>
            <div className="pt-[20px] flex flex-col gap-[20px]">
              {conditionalFormattingFields.map((dataField, dataIndex) => (
                <div key={dataField.id} className="">
                  <div className={fieldAndLabelBlock}>
                    <div></div>
                    <div className={firstBlockValueWidth}>
                      <div className="flex items-center justify-between">
                        <div className="w-[220px]">
                          <div className="flex items-center gap-[10px]">
                            <span className={valuesLabelPathClassName}>
                              {t('conditional_formatting_from')}
                            </span>
                            <Input
                              {...register(
                                `settings.data.${nestedFieldIndex}.conditional_formatting.${dataIndex}.value.0`,
                              )}
                              type="number"
                            />
                            <span className={valuesLabelPathClassName}>
                              {t('conditional_formatting_before')}
                            </span>
                            <Input
                              {...register(
                                `settings.data.${nestedFieldIndex}.conditional_formatting.${dataIndex}.value.1`,
                              )}
                              type="number"
                            />
                            <ColorInput
                              color={watch(
                                `settings.data.${nestedFieldIndex}.conditional_formatting.${dataIndex}.color`,
                              )}
                              changeColor={(color) =>
                                setValue(
                                  `settings.data.${nestedFieldIndex}.conditional_formatting.${dataIndex}.color`,
                                  color,
                                )
                              }
                            />
                          </div>
                        </div>
                        {/*actions*/}
                        <div className=" transition-all duration-[300] flex items-center ">
                          {conditionalFormattingFields.length - 1 === dataIndex && !oneOnly && (
                            <div>
                              <CircleButton
                                onClick={() =>
                                  appendConditionalFormattingField(conditionFormattingDefaultValue)
                                }
                                size={16}
                                className="text-action"
                                icon="PlusIcon"
                              />
                            </div>
                          )}
                          {!oneOnly && (
                            <div>
                              <CircleButton
                                onClick={() => removeConditionalFormattingField(dataIndex)}
                                size={14}
                                className="text-basic_red"
                                icon="TrashIcon"
                              />
                            </div>
                          )}
                        </div>
                        {/*actions*/}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </>
  );
};

export default ConditionalFormattingNestedField;
